const currencyFormatterMap = new Map();

const GBP = Intl.NumberFormat('en', {
  currency: 'GBP',
  style: 'currency',
}).format;
currencyFormatterMap.set('GBP', GBP);

const USD = Intl.NumberFormat('en', {
  currency: 'USD',
  style: 'currency',
}).format;
currencyFormatterMap.set('USD', USD);

const EUR = Intl.NumberFormat('en', {
  currency: 'EUR',
  style: 'currency',
}).format;
currencyFormatterMap.set('EUR', EUR);

const formatCurrency = ({
  amount = 0,
  currencyCode = 'GBP',
  locale = 'en',
  precision = 0,
}: {
  amount: number;
  currencyCode?: string;
  locale?: string;
  precision?: number;
}) => {
  return Intl.NumberFormat(locale, {
    currency: currencyCode,
    style: 'currency',
    maximumFractionDigits: precision,
  }).format(amount);
};

export { currencyFormatterMap, formatCurrency };
